import React from 'react'
import { useTranslation } from 'react-i18next'
import classnames from 'classnames'
import { useSelector } from 'react-redux'

import {
  getAllocationInfo,
  getIsBudgetAllocationType
} from '../../../../../../../forms/Multiplatform/Partnerships/RightForms/RightCreate/RightCreateForm/sectionsLists/OnsiteRightCreateSections/GamOnsiteRightCreateSections/helpers'
import { getUnitTypeLabel } from '../../../../../../../forms/GAM/UploadGamAdCreative/UploadGamAdCreativeForm/LineItemForm/formatters/formatUnitType'
import { capitalizeWords } from '../../../../../../../helpers/common'

import { rightSelector } from '../../../../../../../modules/selectors/rights'

import { BILLING_EVENT } from '../../../../../../../forms/Multiplatform/Partnerships/RightForms/RightCreate/RightCreateForm/sectionsLists/OnsiteRightCreateSections/fields'

import useStyles from './styles'
import useInventoryColumnsStyles from '../styles'

const InventoryListHeader = () => {
  const { t } = useTranslation()
  const classes = useStyles()
  const inventoryListClasses = useInventoryColumnsStyles()

  const right = useSelector(rightSelector)
  const { isPercentageAllocation } = getAllocationInfo(right)
  const isBudgetAllocationType = getIsBudgetAllocationType(right)
  const unitTypeLabel = getUnitTypeLabel(right[BILLING_EVENT])
  const capitalizedUnitTypeLabel = capitalizeWords(unitTypeLabel)

  if (isPercentageAllocation) {
    return (
      <div className={classnames(classes.inventoryListHeader, inventoryListClasses.columnsWrapper)}>
        <div className={inventoryListClasses.allocationColumn}>{t('Percentage allocation')}</div>
        <div className={inventoryListClasses.remainingColumn}>{t('Remaining days')}</div>
      </div>
    )
  } else if (isBudgetAllocationType) {
    return (
      <div className={classnames(classes.inventoryListHeader, inventoryListClasses.columnsWrapper)}>
        <div className={inventoryListClasses.allocationColumn}>{t('Budget Allocation')}</div>
        <div className={inventoryListClasses.remainingColumn}>{t('Remaining Budget')}</div>
      </div>
    )
  } else {
    // quantity allocation
    return (
      <div className={classnames(classes.inventoryListHeader, inventoryListClasses.columnsWrapper)}>
        <div className={inventoryListClasses.allocationColumn}>{t(`${capitalizedUnitTypeLabel} Allocation`)}</div>
        <div className={inventoryListClasses.remainingColumn}>{t(`Remaining ${capitalizedUnitTypeLabel}`)}</div>
      </div>
    )
  }
}

export default InventoryListHeader
